<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> شکایات از سرویس </span>

    </div>

</div>

<form #form="ngForm" (ngSubmit)="search_feedback(form)" dir="rtl" class="form w-100 row gx-2 px-2">

    <ng-container *ngIf="bOption">

        <div class="col-12 col-md-4">

            <label> نام مدرسه </label>

            <input type="search" class="form-control" [(ngModel)]="searchT_School" name="iMobileDomain"
                (input)="filterSchool()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" *ngFor="let item of filteredSchools" (click)="getStudent(item)"
                    [@fadeAnimation]>{{ item.strComment }} </li>

            </ul>

        </div>

        <div class="col-12 col-md-4">

            <label> نام دانش آموز </label>

            <input type="search" class="form-control" [(ngModel)]="searchT_Student" name="iPassenger"
                (input)="filterStudent()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" *ngFor="let item of filteredStudents" [@fadeAnimation]
                    (click)="onStudent_selected(item)">{{item.strPassenger_FullName }} </li>

            </ul>

        </div>

        <div class="col-12 col-md-4">

            <form [formGroup]="dateFilter">

                <label> از تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input dir="ltr" type="text" formControlName="fromDate" class="form-control " />

                </ng-persian-datepicker>

            </form>

        </div>

        <div class="col-12 col-md-4">

            <form [formGroup]="dateFilter">

                <label> تا تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input dir="ltr" type="text" formControlName="toDate" class="form-control " />

                </ng-persian-datepicker>

            </form>

        </div>

        <div class="col-12 col-md-4">

            <label> وضعیت </label>

            <select class="form-control" [ngModel]="-1" name="tiTiketStatus">

                <option value="-1">انتخاب کنید</option>

                <option *ngFor="let item of list_Status" [value]="item.tiTiketStatus"> {{item.strComment}} </option>

            </select>

        </div>

        <div class="col-12 col-md-4">

            <label> موضوع </label>

            <select class="form-control" [ngModel]="-1" name="tiTiketSubject">

                <option value="-1">انتخاب کنید</option>

                <option *ngFor="let item of list_Subject" [value]="item.tiTiketSubject"> {{item.strComment}} </option>


            </select>

        </div>

    </ng-container>

    <div class="col-12  d-flex align-items-end  justify-content-end ">

        <button class="btn mt-2 btn-primary " type="submit" style="width: 201px;"> {{!bOption ? 'جستجو بر اساس' :
            'جستجو' }} </button>

    </div>

</form>

<ng-container *ngIf="!bOption">

    <main class="rtl px-2 mt-2 p-2">

        <div class="d-flex align-items-center">

            <span class="col-12 col-md-6 px-2" *ngIf="list_feedback.length > 0"> تعداد  <span class="text-danger fw-bold ">{{list_feedback.length | faNum}}</span>  مورد یافت شد </span>

            <div class="col-12 col-md-6 text-end " *ngIf="list_feedback.length > 0">
    
                <button class="btn btn-success" (click)="exportExcel()">
        
                    <span> خروجی اکسل </span>
        
                    <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>
        
                </button>
    
            </div>
        
        </div>

        <div class="mt-2 border border-2 p-2">

            <div class="table-responsive" style="max-height: 81vh;">

                <table class="table table-striped" id="Export_Excel">

                    <thead class="position-sticky top-0 bg-white">

                        <tr class="col-12 text-center">

                            <th> # </th>

                            <th> عملیات </th>

                            <th> نام و نام خانوادگی دانش آموز </th>

                            <th> مدرسه</th>

                            <th> موضوع </th>

                            <th> وضعیت </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr class="col-12 text-center" *ngFor="let item of list_feedback;let i = index;">

                            <th> {{ i + 1 | faNum }} </th>

                            <td class="col-1">

                                <i class="fa fa-map-marker fa-lg px-3 btn btn-primary" title="موقعیت"
                                    (click)="showOnMap(item)"></i>

                                <i class="fa fa-user-circle fa-lg my-2 btn btn-success" title="مشخصات دانش آموز"
                                    (click)="studentDetail(item)"></i>

                                <i class="fa fa-info-circle fa-lg  mx-2 btn btn-dark" title="جرئیات"
                                    (click)="showDetail(item)"></i>


                            </td>

                            <td>{{item.strPassenger_FullName | faNum}}</td>

                            <td>{{item.strMobileDomain_strComment | faNum}}</td>

                            <td>{{item.strSchool_TiketSubject_strComment}}</td>

                            <td>{{item.strSchool_TiketStatus_strComment}}</td>

                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

    </main>


</ng-container>

<div class="modal fade" id="detailModal" tabindex="-1" aria-labelledby="" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{!showAction && !previousAction ? 'جزئیات ' : showAction && !previousAction ?
                    ' ثبت اقدام ' : 'اقدامات قبلی' }}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <form *ngIf="!showAction && !previousAction" dir="rtl" class="row p-2 gx-2 gy-2">

                <div class="col-12 col-md-4">

                    <label> نام و نام خانوادگی </label>

                    <input [ngModel]="studentData?.strPassenger_FullName" name="strPassenger_FullName" type="text"
                        class="x form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label> مدرسه </label>

                    <input [ngModel]="studentData?.strMobileDomain_strComment" name="strMobileDomain_strComment"
                        type="text" class="x form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label> موضوع </label>

                    <input [ngModel]="studentData?.strSchool_TiketSubject_strComment"
                        name="strSchool_TiketSubject_strComment" type="text" class="x form-control">

                </div>

                <div class="col-12 x">

                    <textarea [ngModel]="studentData?.strDetail" name="strDetail" placeholder="توضیحات"
                        class="form-control" cols="30" rows="5"></textarea>

                </div>

                <div class="col-12 d-flex justify-content-end ">

                    <button class="btn btn-warning px-5" (click)="show_PreviousAction()"> اقدامات قبلی </button>

                    <button *ngIf="bSaveAction" style="margin-right: 0.5rem!important;" class="btn btn-success px-5"
                        (click)="showAction = true"> ثبت اقدام </button>

                </div>

            </form>

            <form #action="ngForm" (ngSubmit)="addAction(action)" *ngIf="showAction && !previousAction" dir="rtl"
                class="row p-2 gx-2 gy-2">

                <div class="col-12 ">

                    <label> نوع اقدام </label>

                    <select class="form-control" required ngModel name="tiTiketStatus">

                        <option *ngFor="let item of list_ActionType" [value]="item.tiTiketStatus">{{item.strComment}}
                        </option>

                    </select>

                </div>

                <div class="col-12">

                    <textarea ngModel name="strActionDetail" required placeholder="توضیحات" class="form-control"
                        cols="30" rows="5"></textarea>

                </div>

                <div class="col-12 d-flex justify-content-end ">

                    <button class="btn btn-success mx-2 px-5" type="submit"> ثبت </button>

                    <button class="btn btn-danger px-5" (click)="showAction = false"> بازگشت </button>

                </div>

            </form>

            <div *ngIf="previousAction" dir="rtl" class="col-12 p-2">

                <table *ngIf="list_previousAction.length > 0" class="table table-striped"
                    style="max-height: 300px;overflow: auto;">

                    <thead class="position-sticky top-0 bg-white">

                        <tr class="col-12 text-center">

                            <th> # </th>

                            <th> نوع اقدام </th>

                            <th> تاریخ </th>

                            <th> موضوع </th>

                            <th> توضیحات </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr *ngFor="let item of list_previousAction;let i=index;" class="col-12 text-center">

                            <td>{{ i + 1 | faNum}}</td>

                            <td>{{item.strSchool_TiketStatus_strComment}}</td>

                            <td>{{item.strSaveDate | faNum}}</td>

                            <td>{{item.strSchool_TiketSubject_strComment}}</td>

                            <td>{{item.strActionDetail}}</td>

                        </tr>

                    </tbody>

                </table>

                <div class="text-center" *ngIf="list_previousAction.length == 0">

                    <span> هنوز اقدامی ثبت نشده است </span>

                </div>

                <div class="col-12 d-flex justify-content-end ">

                    <button class="btn btn-danger px-5" (click)="previousAction = false"> بازگشت </button>

                </div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="stdLocation" style="z-index: 100000000000000;" tabindex="-1" aria-labelledby=""
    aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> موقعیت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="detail_Std" tabindex="-1" aria-labelledby="" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title">جزئیات دانش آموز</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="text-center">

                <img class="rounded-circle" width="150" height="150"
                    src="{{studentData?.strAvatar != '' ? 'data:image/jpeg;base64,' +  studentData?.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                    alt="">

            </div>

            <div dir="rtl" class="row p-2 gx-2 gy-2">

                <div class="col-12 col-md-4">

                    <label>نام</label>

                    <input type="text" [ngModel]="studentData?.strName" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>نام خانوادگی</label>

                    <input type="text" [ngModel]="studentData?.strFamily" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>جنسیت</label>

                    <input type="text" [ngModel]="studentData?.strSex_strSexComment" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>شماره موبایل</label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.strMobile | faNum )" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label> کد ملی </label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.strNationalCode | faNum)"
                        class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label> نام راننده </label>

                    <input type="text" [ngModel]="studentData?.strFullName" class="form-control">

                </div>

                <div class="col-6">

                    <label>مدرسه</label>

                    <input type="text" [ngModel]="studentData?.strMobileDomain_strComment" class="form-control">

                </div>

                <div class="col-6">

                    <label>فاصله تا مدرسه</label>

                    <input type="text" [ngModel]="( studentData?.fDistance| faNum ) + ' کیلومتر' " class="form-control">

                </div>

                <div class="col-12">

                    <label> آدرس </label>

                    <input type="text" [ngModel]="studentData?.strAddress" class="form-control">

                </div>

                <div class="col-md-6 col-6">

                    <label>طول جغرافیایی</label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.fOriginLon | faNum )" class="form-control">

                </div>

                <div class="col-md-6 col-6">

                    <label>عرض جغرافیایی</label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.fOrigiLat| faNum )" class="form-control">

                </div>

            </div>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>